import React from 'react';
import { List } from 'antd-mobile';
import { t } from '../../../../i18n';

interface AddressItem {
    id: string;
    address: string;
    trackingNumber: string;
    deliveryTaskOrderId: number;
    stopNumber: number | string;
    subStopNumber: string;
    isAbnormal?: boolean;
}

interface AddressListProps {
    addresses: AddressItem[];
    onAddressClick: (address: AddressItem) => void;
}

const AddressList: React.FC<AddressListProps> = ({ addresses, onAddressClick }) => {
    // 去重：相同地址只显示一个，并计算每个地址的订单数量
    const uniqueAddressesWithCount = React.useMemo(() => {
        const addressMap = new Map<string, { address: AddressItem; count: number }>();
        
        addresses.forEach(addr => {
            const existing = addressMap.get(addr.address);
            if (existing) {
                existing.count += 1;
            } else {
                addressMap.set(addr.address, { address: addr, count: 1 });
            }
        });
        
        return Array.from(addressMap.values());
    }, [addresses]);

    if (uniqueAddressesWithCount.length === 0) {
        return null;
    }

    return (
        <div className="h-full overflow-y-auto">
            <div className="p-4">
                <List>
                    {uniqueAddressesWithCount.map((item, index) => (
                        <List.Item
                            key={`${item.address.address}-${index}`}
                            onClick={() => onAddressClick(item.address)}
                            arrow
                            className="border-b border-gray-200 [&_.adm-list-item-content-main]:flex-1 [&_.adm-list-item-content-main]:min-w-0 [&_.adm-list-item-content-main]:pr-2 [&_.adm-list-item-content-arrow]:flex-shrink-0"
                        >
                            <div className="flex items-start gap-2 w-full min-w-0">
                                <div className="text-base font-medium text-gray-900 flex-1 min-w-0 break-words overflow-wrap-anywhere">
                                    {item.address.address}
                                </div>
                                <div className="text-sm text-gray-500 flex-shrink-0 whitespace-nowrap">
                                    ({t(item.count === 1 ? 'pages.delivery.delivering.order' : 'pages.delivery.delivering.orders', {orderCount: item.count })})
                                </div>
                            </div>
                        </List.Item>
                    ))}
                </List>
            </div>
        </div>
    );
};

export default AddressList;

